import chunk from 'lodash/chunk';

import type { IconConfig } from '@repo/sdk/models/components';

/** Maximum icon slots per shelf row before wrapping to the next row. */
export const SHELF_ICONS_PER_ROW = 5;

/** Splits icons into rows of at most {@link SHELF_ICONS_PER_ROW} for full-width equal distribution. */
export const chunkShelfIconsIntoRows = (
  icons: IconConfig[],
  iconsPerRow = SHELF_ICONS_PER_ROW
): IconConfig[][] => chunk(icons, iconsPerRow);
